import React, { Fragment, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import ChartRenderingContainer from "./components/Chart_rendering/Container";
import Signin from "./components/authentication/Signin";
import OpCen2 from "./components/bakun/OpCen2";
import Events from "./components/bakun/Events";
import Communication from "./components/bakun/Communication";
import Analysis from "./components/bakun/Analysis";
import BakunHeader from "./components/utils/BakunHeader";
import CRA from "./components/bakun/CRA";
import GroundData from "./components/bakun/GroundData";
import CaV from "./components/bakun/CaV";
import Rainfall from "./components/bakun/Rainfall";
import Subsurface from "./components/bakun/Subsurface";
import Surficial from "./components/bakun/Surficial";
import Earthquake from "./components/bakun/Earthquake";
import SurficialMarkers from "./components/bakun/SurficialMarkers";
import Moms from "./components/bakun/Moms";
import Feedback from "./components/bakun/Feedback";
import ChangePassword from "./components/utils/ChangePassword";
import ProfileSettings from "./components/utils/ProfileSettings";
import Bulletin from "./components/utils/Bulletin";
import "./components/bakun/css/sandbox.css";
import "./components/bakun/css/embla.css";

import { CBEWSL_SITE_NAME } from "./host";

const App = (props) => {
  const [nav, setNav] = useState(null);
  const [site, setSite] = useState("");
  const Header = () => {
    let location = window.location.pathname;

    if (location !== "/signin" && location !== "" && location !== "/") {
      if (localStorage.getItem("bak_credentials") !== null) {
        return <BakunHeader />;
      }
    } else {
      if (localStorage.getItem("bak_credentials") !== null) {
        window.location = "/opcen";
      }
    }
  };

  return (
    <Fragment>
      <SnackbarProvider>
        <Router>
          {Header()}

          <Routes>
            <Route exact path={`/`} element={<Signin />} />
            <Route exact path={`/signin`} element={<Signin />} />
            <Route exact path={`/feedback`} element={<Feedback />} />
            {/* <Route
              path="*"
              element={
                <main style={{ padding: "1rem" }}>
                  <h2>Webpage not found</h2>
                </main>
              }
            /> */}
          </Routes>

          {localStorage.getItem("bak_credentials") != null && (
            <Routes>
              <Route exact path={`/opcen`} element={<OpCen2 />} />
              <Route exact path={`/bulletin`} element={<Bulletin />} />
              <Route exact path={`/events`} element={<Events />} />
              <Route
                exact
                path={`/communication`}
                element={<Communication />}
              />
              <Route exact path={`/analysis`} element={<Analysis />} />
              <Route exact path={`/cra`} element={<CRA />} />
              <Route exact path={`/ground_data`} element={<GroundData />} />
              <Route exact path={`/cav`} element={<CaV />} />
              <Route exact path={`/rainfall`} element={<Rainfall />} />
              <Route exact path={`/subsurface`} element={<Subsurface />} />
              <Route exact path={`/surficial`} element={<Surficial />} />
              <Route exact path={`/earthquake`} element={<Earthquake />} />
              <Route
                exact
                path={`/change-password`}
                element={<ChangePassword />}
              />
              <Route
                exact
                path={`/profile-settings`}
                element={<ProfileSettings />}
              />
              <Route
                exact
                path={`/surficial_markers`}
                element={<SurficialMarkers />}
              />
              <Route exact path={`/moms`} element={<Moms />} />
            </Routes>
          )}
        </Router>
      </SnackbarProvider>
    </Fragment>
  );
};

export default App;
